import React, {ReactNode} from 'react';
import {observer} from "mobx-react-lite";
import {screenSizeProvider} from "../../stores/ScreenSizeProvider";


export interface HiddenOnMobileProps {
    children: ReactNode;
}

export const HiddenOnMobile = observer(
    (
        {
            children
        }: HiddenOnMobileProps
    ) => {
        const isMobile = screenSizeProvider.view !== 'desktop';

        if (isMobile) {
            return null;
        }

        return (
            <>
                {children}
            </>
        )
    }
)
